import { EventEmitter, Input, Output, OnChanges } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ReportsService } from '../../../services';
import { map, take } from 'rxjs/operators';
import * as _ from 'lodash';
import { TGSFormControl, Store, AppState, AppFields, ClubProgram, finalize } from '../../../store';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';

export class ReportBase implements OnChanges {

  @Input() reports;
  @Input() searchOpened: boolean;
  @Output() searchOpenedChange: EventEmitter<boolean> = new EventEmitter();
  @Output() controlChange: EventEmitter<any[]> = new EventEmitter();
  program: Observable<ClubProgram>;
  clubProgramId: Observable<any>;
  count1 = 0;
  count2 = 0;
  checked: boolean[] = [];
  report: any;
   reportsList:any[] = [];
  usersList;
  controls: TGSFormControl[];
  _reports: any[];
  itemsPerPage = 20;
  p = 1;

  constructor(
    protected service: ReportsService,
    protected store: Store<AppState>,
    public loadingService?: Ng4LoadingSpinnerService
  ) {
    this.program = this.store.select(AppFields.App, AppFields.Program);
    this.clubProgramId = this.program.pipe(take(1), map((p: ClubProgram) => p && p.clubprogramID));
  }

  ngOnChanges(data) {
    if (data.searchOpened) {
      this.searchOpened ? this.openSearchPanel() : this.closeSearchPanel();
    }
  }

  pullData(sub) {
    if (this.loadingService) {
      this.loadingService.show();
    }

    this.clubProgramId.pipe(
      take(1)
    ).subscribe(id => {
      this.service[sub](id).pipe(
        map((res: any) => (res.list = _.sortBy(res.list, 'lastName'), res)),
        finalize(() => {
          if (this.loadingService) {
            this.loadingService.hide();
          }
        })
      ).subscribe(res => {
        this.report = res;
        this._reports = this.report.list.slice();
        this.checked =  new Array(this.report.list.length).fill(false);
        this.usersList = _.uniqBy(res.list.filter(item => item.email && item.firstName).map(item => ({
          email: item.email,
          name: `${item.firstName} ${item.lastName}`
        })), 'email');

        if (this.controls) {
          const cardType = this.controls.find(c => c.name === 'cardtype');
          if (cardType) {
            cardType.options = _.uniq<string>(this.report.list.map(r => r.cardtype)).map(t => ({ value: t, text: t }));
          }

          this.updateControls();
        }

      });
    });
  }

  get selectedUsers() {
    return (this._reports || []).filter((r, idx) => this.checked[idx]).map(r => r.userID);
  }

  get selectedUsersList() {
    return (this._reports || []).filter((r, idx) => this.checked[idx]);
  }

  get allChecked(): boolean {
    return this.checked && this.checked.length && this.checked.every(c => c);
  }

  set allChecked(value: boolean) {
    this.checked.fill(value);
  }

  openSearchPanel() {
    this.searchOpened = true;
    this.searchOpenedChange.emit(true);
  }

  closeSearchPanel() {
    this.searchOpened = false;
    this.searchOpenedChange.emit(false);
  }

  search(f) {
    if (!this.report) {
      return;
    }

    const filters = this.controls.filter(control => f[control.name]);
    if (filters.length) {
      this.report.list = this._reports.filter(r => {
        return filters.every(control => control.type === 'cdate' ? true :
          control.type === 'text' ? (r[control.name] || '').toLowerCase().includes(f[control.name].toLowerCase().trim())
          : control.type === 'date' ? new Date(r[control.name]).toDateString() === new Date(f[control.name]).toDateString()
          : (r[control.name] && r[control.name].toLowerCase()) === (f[control.name] && f[control.name].toLowerCase())
        );
      });
      console.log(this.report);
    } else {
      this.report.list = this._reports;
    }
    this.checked =  new Array(this.report.list.length).fill(false);
    this.usersList = _.uniqBy(this.report.list.filter(item => item.email && item.firstName).map(item => ({
      email: item.email,
      name: `${item.firstName} ${item.lastName}`
    })), 'email');
  }

  updateControls() {
    this.controlChange.emit(this.controls);
  }

  get isChecked(): boolean {
    return this.checked.some(x => x);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/clubprogram-reports/components/report.base.ts